<div class="card pad15 ">
    <ul ngbNav #nav="ngbNav" class="nav-pills subtab">
        <li *ngFor="let tab of tabs" class="nav-item">
            <a translate class="nav-link" (click)="selectedTabs=tab.id" [ngClass]="{'active': selectedTabs===tab.id}">{{tab.label}}</a>
        </li>
    </ul>

</div>
<ng-cotainer *ngIf="selectedTabs===1">
    <app-add-additional-work-job></app-add-additional-work-job>
  </ng-cotainer>
  <ng-cotainer *ngIf="selectedTabs===2">
    <app-wo-confirmation></app-wo-confirmation>
  </ng-cotainer>
<div [ngbNavOutlet]="nav" class="mt-2"></div>